import React, { cloneElement } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import useInputError from 'hooks/useInputError'

import { ChevronDownIcon, InputErrorMessage, Label } from 'components'
import WarningDot from 'components/Profile/WarningDot'

const Select = ({
  label,
  onError,
  classNames,
  styles,
  icon,
  onChange,
  onInvalid,
  showRequired,
  ...rest
}) => {
  const { errorMessage, handleError, setErrorMessage } = useInputError(onError)
  return (
    <Label
      label={label}
      styles={{ label: styles.label, span: styles.labelText }}
      classNames={{ label: classNames.label, span: classNames.labelText }}
    >
      <div className="relative">
        {icon &&
          cloneElement(icon, {
            className: classnames(
              icon.props.className,
              'absolute left-2 top-1/2 transform -translate-y-1/2 pointer-events-none'
            ),
          })}
        <select
          onChange={e => {
            setErrorMessage(null)
            onChange(e)
          }}
          onInvalid={e => {
            handleError(e)
            onInvalid(e)
          }}
          className={classnames(
            'form-select block w-full outline-none',
            {
              [classNames.error]: errorMessage,
              [classNames.noError]: !errorMessage,
              'pl-10': !!icon,
            },
            classNames.select
          )}
          style={styles.select}
          {...rest}
        />
        {showRequired && !rest.value ? (
          <WarningDot className="absolute top-1/2 right-4 transform -translate-y-1/2" />
        ) : (
          <ChevronDownIcon
            className={classnames(
              'w-4 h-4 absolute right-6 top-1/2 transform -translate-y-1/2 pointer-events-none text-white',
              classNames.chevron
            )}
            style={styles.chevron}
          />
        )}
      </div>
      {errorMessage && <InputErrorMessage>{errorMessage}</InputErrorMessage>}
    </Label>
  )
}

Select.propTypes = {
  label: PropTypes.string,
  onError: PropTypes.func,
  icon: PropTypes.element,
  classNames: PropTypes.shape({
    label: PropTypes.string,
    labelText: PropTypes.string,
    select: PropTypes.string,
    noError: PropTypes.string,
    error: PropTypes.string,
    chevron: PropTypes.string,
  }),
  styles: PropTypes.shape({
    label: PropTypes.object,
    labelText: PropTypes.object,
    select: PropTypes.object,
    chevron: PropTypes.object,
  }),
}

Select.defaultProps = {
  classNames: {},
  styles: {},
  onError: e => e.target.validationMessage,
  onChange: () => {},
  onInvalid: () => {},
}

export default Select
